/* eslint-disable no-use-before-define */

const $LOG = Symbol('log');
const $HTTP = Symbol('$http');
const $Q = Symbol('$q');

class ContactService {
  static factory($q, $http, $log) {// eslint-disable-line no-unused-vars
    'ngInject';
    return new ContactService(...arguments);
  }

  constructor($q, $http, $log) {
    this[$Q] = $q;
    this[$HTTP] = $http;
    this[$LOG] = $log;
  }

  sendEmail(data) {
    return this.post(data);
  }

  post(data) {
    return this.request('post', data);
  }

  request(method, data) {
    let request;
    const url = 'https://wqycerodtb.execute-api.us-east-1.amazonaws.com/production/contact-form';
    const deferred = this[$Q].defer();

    request = this[$HTTP].post(url, data);

    request.then(res => {
      resolve(deferred, res);
    }).catch(deferred.reject);

    return deferred.promise;
  }

}

function resolve(promise, res) {
  if (res.data && res.data.data) {
    promise.resolve(res.data.data);
  } else if (res.data) {
    promise.resolve(res.data);
  } else {
    promise.resolve(res);
  }
}

export default ContactService;
